import React from 'react';
import {View} from '@react-pdf/renderer';
import {IntlShape} from 'react-intl';
import PlateToPdf from '../PlateToPdf';
import QuotePage from './QuotePage';
import SectionLabel from './SectionLabel';
import {stylesFor} from './quotePdfStyles';
import type {QuoteDocumentData, QuoteTemplate} from '../resolver/types';
import {sectionBody, sectionEnabled} from '../persistence/quoteTemplateSchema';
import {sectionTitle} from '../config/defaultTemplate';

type QuoteNarrativePageProps = {
	data: QuoteDocumentData;
	template: QuoteTemplate;
	intl: IntlShape;
};

/**
 * Introduction and Scope of work — two independently toggleable narrative sections. The page
 * itself is only rendered when at least one of them is on.
 */
const QuoteNarrativePage = ({data, template, intl}: QuoteNarrativePageProps): JSX.Element => {
	const styles = stylesFor(template);
	return (
		<QuotePage data={data} template={template} intl={intl}>
			{sectionEnabled(template, 'INTRODUCTION') && (
				<View style={styles.section}>
					<SectionLabel template={template}>{sectionTitle(template, 'INTRODUCTION', intl)}</SectionLabel>
					<PlateToPdf value={sectionBody(template, 'INTRODUCTION')} baseStyle={styles.paragraph} />
				</View>
			)}
			{sectionEnabled(template, 'SCOPE') && (
				<View style={styles.section}>
					<SectionLabel template={template}>{sectionTitle(template, 'SCOPE', intl)}</SectionLabel>
					<PlateToPdf value={sectionBody(template, 'SCOPE')} baseStyle={styles.paragraph} />
				</View>
			)}
		</QuotePage>
	);
};

export default QuoteNarrativePage;
